export class Payment {

    public cartTotal: number;
    public transactions: Transaction[];
    public additions: Addition[];
    private _totalTransactionValue: number;
    private _remainingValue: number;
    private _activeDiscount: number;
    private _grandTotal: number;
    

    constructor(
        theCartTotal: number,
        theTransactions: Transaction[] | [],
        theAdditions: Addition[] | []
        ) {
            this.cartTotal = theCartTotal;
            this.transactions = theTransactions;
            this.additions = theAdditions;
    }

    get totalTransactionValue() {
        return this.transactions.reduce((sum, trn) => sum = sum + trn.transValue, 0);
    }

    get remainingValue() {
        return this.grandTotal - this.totalTransactionValue;
    }

    get activeDiscount() {
        return this.remainingValue / this.grandTotal;
    }

    get grandTotal() {
        const addCosts = this.additions.filter(adt => adt.discount === false).reduce((sum, val) => sum = sum + val.amount, 0);
        const addDiscounts = this.additions.filter(adt => adt.discount === true).reduce((sum, val) => sum = sum + val.amount, 0);

        return this.cartTotal + 
            addCosts - addDiscounts;
    }



    // get transactionValue() {
    //     return this.transactions.map(trns => {
    //         return {
    //             type: trns.type,
    //             amount: trns.amount,
    //             // value: KATSAYIYLA ÇARP
    //         }
    //     })
    // }

    changePayment(thePayment: Payment) {
        console.log('payment class lvl1: ', this.transactions);
        this.transactions = thePayment.transactions;
        console.log('payment class lvl2: ', this.transactions);
        const artTotTrnsVal = this.transactions.reduce((sum, trn) => sum + trn.transValue, 0);
        console.log('artTotTrnsVal: ', artTotTrnsVal);
        // console.log('payment class lvl: ', )
    }

    changeCartTotal(value: number) {
        this.cartTotal = value;
    }

}

export interface Transaction {
    paymentNo: number;
    type: string;
    amount: number;
    transValue: number;
    commission: number;

}

export interface Addition {
    discount: boolean;
    name: string;
    amount: number;
}
